import { render } from "./settings-add-signal.vue?vue&type=template&id=b94ef862"
import script from "./settings-add-signal.vue?vue&type=script&lang=js"
export * from "./settings-add-signal.vue?vue&type=script&lang=js"

import "./settings-add-signal.vue?vue&type=style&index=0&id=b94ef862&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__